/**
 * App-wide: hovering text cut off with an ellipsis shows the full text (native tooltip). One document listener covers
 * every grid cell and header, and Tailwind `truncate` text, so no page needs its own tooltip config. A title an
 * element already has is left alone.
 */
const SELECTOR = '.ag-cell-value, .ag-cell, .ag-header-cell-text, .truncate';
const AUTO = 'autoTitle';

export function syncTruncatedTitle(el: HTMLElement): void {
    if (el.title && el.dataset[AUTO] === undefined) return; // the page's own title
    const text = (el.textContent ?? '').trim();
    const cut = el.scrollWidth > el.clientWidth + 1 || el.scrollHeight > el.clientHeight + 1;
    if (cut && text) {
        el.title = text;
        el.dataset[AUTO] = '1';
    } else if (el.dataset[AUTO] !== undefined) {
        el.removeAttribute('title');
        delete el.dataset[AUTO];
    }
}

export function installTruncatedTextTitles(doc: Document): () => void {
    const onOver = (e: Event) => {
        const el = (e.target as Element | null)?.closest?.(SELECTOR) as HTMLElement | null;
        if (el) syncTruncatedTitle(el);
    };
    doc.addEventListener('mouseover', onOver, { passive: true });
    return () => doc.removeEventListener('mouseover', onOver);
}
